import * as React from "react";
import { Modal, Form, Button, Grid, Container } from "semantic-ui-react";
import { Input } from "@neworbit/simpleui-input";
import { useDispatch } from "@teamprevent/admin-redux";

import { goToParent } from "@teamprevent/common/routing";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { TextSnippetSelector } from "@teamprevent/common/components/TextSnippetSelector";

import { submitPpqDeclarationReview } from "../actions";
import { SUBMIT_PPQ_DECLARATION_REVIEW } from "../actionTypes";

interface Props {
    customerId: string;
    ohCaseId: string;
    taskId: string;
    ppqId: string;
}

const PpqDeclarationReviewModal: React.FunctionComponent<Props> = (props) => {
    const [notes, setNotes] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);
    const dispatch = useDispatch();

    const onSubmit = async () => {
        setSubmitted(true);
        if (!notes) {
            return;
        }
        await dispatch(submitPpqDeclarationReview(props.customerId, props.ohCaseId, props.taskId, notes));
        dispatch(goToParent());
    };

    const onCancel = () => dispatch(goToParent());

    const updateNotes = (snippetText: string) => {
        setNotes(notes + " " + snippetText);
    };

    return (
        <Modal open>
            <Modal.Header>
                <Grid columns="equal">
                    <Grid.Column>Review PPQ Declaration</Grid.Column>
                    <Grid.Column>
                        <a
                            href={`/case/${props.ppqId}/ppq`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button floated="right" content="Review PPQ" />
                        </a>
                    </Grid.Column>
                </Grid>
            </Modal.Header>
            <Modal.Content>
                <Container textAlign="right" fluid>
                    <TextSnippetSelector onSelect={updateNotes} />
                </Container>
                <Form>
                    <Input.Textarea showErrors={submitted} required label="Notes" value={notes} onChange={setNotes} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onCancel}>Cancel</Button>
                <IsLoadingButton requestNames={SUBMIT_PPQ_DECLARATION_REVIEW} onClick={onSubmit}>Submit</IsLoadingButton>
            </Modal.Actions>
        </Modal>
    );
};

export { PpqDeclarationReviewModal };
